// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H4CRJnSRKY5a_I {
  justify-content: flex-start;
  width: 100%;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-background-neutral-subtle, #00000000);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-regular, 400);
}
.H4CRJnSRKY5a_I:hover {
  background-color: var(--ds-background-neutral-subtle-hovered, #091e420f);
}
.H4CRJnSRKY5a_I .XTd91xrSkjN3zk {
  margin-left: var(--ds-space-050, 3px);
}
.YYRfNoEtCHWP55 > span {
  flex-shrink: 0;
  margin-right: var(--ds-space-150, 11px);
}
`, ""]);
// Exports
export var boardMenuButton = `H4CRJnSRKY5a_I`;
export var buttonContents = `XTd91xrSkjN3zk`;
export var buttonIcon = `YYRfNoEtCHWP55`;
export default ___CSS_LOADER_EXPORT___;
